export const GELIOS = 'gelios';
export const KIDOPOLIS = 'kidopolis';
